import { Box, TextareaAutosize, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type TextareaKitProps = {
  name: string;
  placeholder?: string | null;
  disabled?: boolean;
};

export const TextareaKit = ({
  name,
  placeholder,
  disabled,
}: TextareaKitProps) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const inputValue = watch(name) || '';

  const errorMessage: any = !!errors[name]?.message
    ? errors[name]?.message
    : '';

  const isError = !!errorMessage;

  return (
    <Box>
      {!!isError && (
        <Typography
          sx={{ marginBottom: '10px', color: 'red', fontSize: '14px' }}
        >
          {errorMessage}
        </Typography>
      )}
      <TextareaAutosize
        style={{
          fontFamily: 'Inter',
          padding: '15px 10px',
          resize: 'none',
          borderColor: '#E3DDE6',
          width: '100%',
        }}
        minRows={5}
        value={inputValue}
        placeholder={placeholder || 'Answer here'}
        disabled={disabled}
        {...register(name)}
      />
    </Box>
  );
};
